/*global FileList, File */
import React from "ES/lib/react";

require("./DropFileInput.less");

var component = React.createFactory(React.createClass({
    __onChange: function(e){
        var files = e.target.files;
        if(files.length !== 1){
            this.props.onChange(void 0);
            return;
        }
        var file = files[0];

        this.props.onChange(file);
    },
    render: function(){
        var field = this.props.field;
        var value = this.props.value;

        if(typeof FileList === "undefined"){
            return <p className="form-control-static text-danger">
                Your browser is outdated and will not work with this file upload.
            </p>;
        }

        var filename = value && value.name ? value.name : "";

        if(field.read_only){
            return <p className="form-control-static">
                {filename}
            </p>;
        }

        return <div className="DropFileInput">
            <div className="DropFileInput-wrap">
                <div>
                    <i
                        className="fa fa-cloud-upload text-muted"
                        style={{fontSize: "2em"}}
                    />
                    {" "}
                     {filename}
                </div>
                <div>
                    <a>Browse</a>
                    {" or drag and drop a PDF here to upload."}
                </div>
            </div>
            <input
                type="file"
                className="DropFileInput-file-input"
                name={field.name}
                onChange={this.__onChange}
            />
        </div>;
    }
}));

export default {
    component: component,
    validate: function(value){
        return value instanceof File
            ? true
            : "You must select a file to upload";
    }
};



// WEBPACK FOOTER //
// ./src/components/inputs/DropFileInput.js